export default "__VITE_ASSET__BH1jYU8j__"